import { createFileRoute } from '@tanstack/react-router';
import { InvoicesOverview } from '@uturn/portal/modules/invoices/pages/overview';

export const Route = createFileRoute('/_protected/invoices')({
	component: InvoicesOverview,
});
